import React from 'react'

export const OutlookEmailProvider: React.FC<
  React.SVGProps<SVGSVGElement>
> = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_11332_1565)">
        <path
          d="M22.5 12.5002C22.5006 12.4175 22.4798 12.3361 22.4397 12.2638C22.3996 12.1916 22.3415 12.1309 22.271 12.0877H22.2685L22.2595 12.0827L14.8095 7.67267C14.7773 7.65093 14.744 7.63107 14.7095 7.61317C14.5677 7.54003 14.4105 7.50186 14.251 7.50186C14.0915 7.50186 13.9343 7.54003 13.7925 7.61317C13.7581 7.63107 13.7247 7.65093 13.6925 7.67267L6.24251 12.0827L6.23351 12.0877C6.16246 12.1318 6.10404 12.1936 6.0639 12.2671C6.02377 12.3405 6.00328 12.423 6.00444 12.5067C6.0056 12.5903 6.02835 12.6723 6.0705 12.7445C6.11265 12.8168 6.17277 12.877 6.24501 12.9192L13.695 17.3292C13.7273 17.3507 13.7607 17.3706 13.795 17.3887C13.9368 17.4618 14.094 17.5 14.2535 17.5C14.413 17.5 14.5702 17.4618 14.712 17.3887C14.7464 17.3706 14.7797 17.3507 14.812 17.3292L22.262 12.9192C22.3351 12.8765 22.3957 12.8153 22.4375 12.7417C22.4793 12.6681 22.5008 12.5848 22.5 12.5002Z"
          fill="#0A2767"
        />
        <path
          d="M7.11076 9.55565H11.9998V14.0372H7.11076V9.55565ZM21.4998 5.00015V2.95015C21.5054 2.704 21.4131 2.46568 21.2431 2.28755C21.0731 2.10942 20.8394 2.00605 20.5933 2.00015H7.90626C7.66011 2.00605 7.42638 2.10942 7.2564 2.28755C7.08643 2.46568 6.99412 2.704 6.99976 2.95015V5.00015L14.4998 7.00015L21.4998 5.00015Z"
          fill="#0364B8"
        />
        <path d="M7 5.00015H12V9.50015H7V5.00015Z" fill="#0078D4" />
        <path
          d="M17 5.00015H12V9.50015L17 14.0002H21.5V9.50015L17 5.00015Z"
          fill="#28A8EA"
        />
        <path d="M12 9.50015H17V14.0002H12V9.50015Z" fill="#0078D4" />
        <path d="M12 14.0002H17V18.5002H12V14.0002Z" fill="#0364B8" />
        <path
          d="M7.11084 14.0372H11.9998V18.1112H7.11084V14.0372Z"
          fill="#14447D"
        />
        <path d="M17 14.0002H21.5V18.5002H17V14.0002Z" fill="#0078D4" />
        <path
          d="M22.271 12.8917L22.2615 12.8967L14.8115 17.0867C14.779 17.1067 14.746 17.1257 14.7115 17.1427C14.585 17.2029 14.4475 17.2369 14.3075 17.2427L13.9005 17.0047C13.8661 16.9874 13.8327 16.9682 13.8005 16.9472L6.2505 12.6382H6.247L6 12.5002V20.9822C6.00185 21.2539 6.11155 21.5138 6.30498 21.7047C6.49841 21.8956 6.75974 22.0019 7.0315 22.0002H21.4845C21.493 22.0002 21.5005 21.9962 21.5095 21.9962C21.629 21.9885 21.7469 21.9639 21.8595 21.9232C21.9082 21.9025 21.9551 21.8781 22 21.8502C22.0335 21.8312 22.091 21.7897 22.091 21.7897C22.2173 21.6962 22.3201 21.5745 22.3911 21.4343C22.4621 21.2941 22.4994 21.1393 22.5 20.9822V12.5002C22.4999 12.5798 22.4787 12.6581 22.4384 12.7269C22.3982 12.7956 22.3404 12.8525 22.271 12.8917Z"
          fill="url(#paint0_linear_11332_1565)"
        />
        <path
          opacity="0.5"
          d="M22.1 12.4666V12.9866L14.31 18.3501L6.245 12.6416C6.245 12.6402 6.24447 12.639 6.24354 12.638C6.2426 12.6371 6.24133 12.6366 6.24 12.6366L5.5 12.1916V11.8166L5.805 11.8116L6.45 12.1816L6.465 12.1866L6.52 12.2216C6.52 12.2216 14.1 16.5466 14.12 16.5566L14.41 16.7266C14.435 16.7166 14.46 16.7066 14.49 16.6966C14.505 16.6866 22.015 12.4616 22.015 12.4616L22.1 12.4666Z"
          fill="#0A2767"
        />
        <path
          d="M22.271 12.8917L22.2615 12.8972L14.8115 17.0872C14.779 17.1072 14.746 17.1262 14.7115 17.1432C14.5687 17.2129 14.4119 17.2492 14.253 17.2492C14.0941 17.2492 13.9373 17.2129 13.7945 17.1432C13.7602 17.1262 13.7269 17.1075 13.6945 17.0872L6.2445 12.8972L6.2355 12.8917C6.16487 12.8534 6.10578 12.7969 6.06437 12.728C6.02296 12.6592 6.00073 12.5805 6 12.5002V20.9822C6.00085 21.1167 6.02819 21.2497 6.08047 21.3737C6.13274 21.4977 6.20892 21.6102 6.30466 21.7047C6.4004 21.7992 6.51382 21.874 6.63844 21.9247C6.76307 21.9754 6.89646 22.001 7.031 22.0002H21.469C21.6035 22.001 21.7369 21.9754 21.8616 21.9247C21.9862 21.874 22.0996 21.7992 22.1953 21.7047C22.2911 21.6102 22.3673 21.4977 22.4195 21.3737C22.4718 21.2497 22.4991 21.1167 22.5 20.9822V12.5002C22.4999 12.5798 22.4787 12.6581 22.4384 12.7269C22.3982 12.7956 22.3404 12.8525 22.271 12.8917Z"
          fill="#1490DF"
        />
        <path
          opacity="0.1"
          d="M14.9199 17.025L14.8084 17.0875C14.7761 17.1081 14.7427 17.1269 14.7084 17.144C14.5856 17.2043 14.452 17.2396 14.3154 17.248L17.1499 20.6L22.0944 21.7915C22.2299 21.6892 22.3377 21.5546 22.4079 21.4L14.9199 17.025Z"
          fill="black"
        />
        <path
          opacity="0.05"
          d="M15.4249 16.7409L14.8084 17.0874C14.7761 17.108 14.7427 17.1269 14.7084 17.1439C14.5856 17.2042 14.452 17.2396 14.3154 17.2479L15.6434 20.9094L22.0959 21.7899C22.2213 21.6958 22.3231 21.5738 22.3932 21.4336C22.4633 21.2933 22.4999 21.1387 22.4999 20.9819V20.8724L15.4249 16.7409Z"
          fill="black"
        />
        <path
          d="M7.045 22.0002H21.4675C21.6894 22.0013 21.9059 21.9312 22.085 21.8002L13.9 17.0057C13.8656 16.9884 13.8322 16.9692 13.8 16.9482L6.25 12.6392H6.2465L6 12.5002V20.9532C5.99987 21.0905 6.02679 21.2266 6.07924 21.3535C6.13168 21.4805 6.20862 21.5959 6.30566 21.6931C6.4027 21.7903 6.51793 21.8675 6.64479 21.9201C6.77165 21.9728 6.90764 22 7.045 22.0002Z"
          fill="#28A8EA"
        />
        <path
          opacity="0.1"
          d="M13 6.9165V17.5815C12.9996 17.7643 12.9446 17.9428 12.8422 18.0942C12.7398 18.2456 12.5945 18.3631 12.425 18.4315C12.3176 18.4777 12.2019 18.5015 12.085 18.5015H6V6.5H7V6H12.085C12.3276 6.00092 12.5601 6.09783 12.7315 6.26955C12.903 6.44127 12.9995 6.67385 13 6.9165Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M12.5 7.41669V18.0817C12.5013 18.2025 12.4756 18.322 12.425 18.4317C12.3571 18.599 12.241 18.7424 12.0914 18.8437C11.9419 18.9449 11.7656 18.9994 11.585 19.0002H6V6.50019H11.585C11.7301 6.49874 11.8731 6.53492 12 6.60519C12.1503 6.68092 12.2766 6.79687 12.3649 6.94015C12.4532 7.08343 12.4999 7.2484 12.5 7.41669Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M12.5 7.41669V17.0817C12.4988 17.3243 12.4022 17.5567 12.2309 17.7286C12.0597 17.9005 11.8276 17.9981 11.585 18.0002H6V6.50019H11.585C11.7301 6.49874 11.8731 6.53492 12 6.60519C12.1503 6.68092 12.2766 6.79687 12.3649 6.94015C12.4532 7.08343 12.4999 7.2484 12.5 7.41669Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M12 7.41665V17.0817C11.9997 17.3246 11.9034 17.5575 11.7319 17.7296C11.5605 17.9017 11.3279 17.999 11.085 18.0002H6V6.50015H11.085C11.2053 6.50022 11.3243 6.52398 11.4354 6.57008C11.5465 6.61618 11.6474 6.68372 11.7324 6.76883C11.8174 6.85394 11.8847 6.95496 11.9306 7.06611C11.9766 7.17727 12.0001 7.29639 12 7.41665Z"
          fill="black"
        />
        <path
          d="M11.0835 6.50015H1.9165C1.41033 6.50015 1 6.91048 1 7.41665V16.5837C1 17.0898 1.41033 17.5002 1.9165 17.5002H11.0835C11.5897 17.5002 12 17.0898 12 16.5837V7.41665C12 6.91048 11.5897 6.50015 11.0835 6.50015Z"
          fill="url(#paint1_linear_11332_1565)"
        />
        <path
          d="M3.8644 10.3437C4.09028 9.86246 4.4549 9.45971 4.9114 9.18723C5.41696 8.89779 5.99259 8.75349 6.5749 8.77023C7.11461 8.75852 7.64716 8.89533 8.1144 9.16573C8.55371 9.42771 8.90752 9.81157 9.1329 10.2707C9.37835 10.7767 9.50068 11.3335 9.4899 11.8957C9.5018 12.4833 9.37594 13.0655 9.1224 13.5957C8.89165 14.0713 8.52661 14.4688 8.0724 14.7392C7.58715 15.0179 7.03483 15.1583 6.4754 15.1452C5.92417 15.1585 5.37986 15.0202 4.9019 14.7452C4.4588 14.4829 4.10055 14.0986 3.8699 13.6382C3.623 13.1396 3.49921 12.5891 3.5089 12.0327C3.49862 11.4501 3.62015 10.8727 3.8644 10.3437ZM4.9804 13.0587C5.10084 13.363 5.30507 13.6269 5.5694 13.8197C5.83864 14.0079 6.16103 14.105 6.4894 14.0967C6.83911 14.1106 7.18381 14.0102 7.4714 13.8107C7.73238 13.6185 7.93125 13.3539 8.0434 13.0497C8.16877 12.7101 8.23063 12.3503 8.2259 11.9882C8.22978 11.6227 8.17162 11.2593 8.0539 10.9132C7.94993 10.6008 7.75747 10.3253 7.4999 10.1202C7.21951 9.91134 6.87573 9.8054 6.5264 9.82023C6.19092 9.81154 5.8613 9.90939 5.5849 10.0997C5.3161 10.2934 5.10799 10.5596 4.9849 10.8672C4.71185 11.5723 4.71043 12.3537 4.9809 13.0597L4.9804 13.0587Z"
          fill="white"
        />
        <path d="M17 5.00015H21.5V9.50015H17V5.00015Z" fill="#50D9FF" />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_11332_1565"
          x1="14.25"
          y1="12.5002"
          x2="14.25"
          y2="22.0002"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#35B8F1" />
          <stop offset="1" stopColor="#28A8EA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_11332_1565"
          x1="2.911"
          y1="5.78415"
          x2="10.089"
          y2="18.2162"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1784D9" />
          <stop offset="0.5" stopColor="#107AD5" />
          <stop offset="1" stopColor="#0A63C9" />
        </linearGradient>
        <clipPath id="clip0_11332_1565">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
